'use client'
const isFiatToken = (symbol) => symbol === 'USD';

export { isFiatToken };
